import { render, staticRenderFns } from "./PointsTab.vue?vue&type=template&id=bf9d6c6a&scoped=true"
import script from "./PointsTab.vue?vue&type=script&lang=js"
export * from "./PointsTab.vue?vue&type=script&lang=js"
import style0 from "./PointsTab.vue?vue&type=style&index=0&id=bf9d6c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d6c6a",
  null
  
)

export default component.exports